import type { GetSelectionAreaRgb } from "./types";

// Red reads as "cut out of the exports"; green marks include areas that keep their content.
export const EXCLUDE_SELECTION_AREA_RGB: [number, number, number] = [
  220, 38, 38,
];
export const INCLUDE_SELECTION_AREA_RGB: [number, number, number] = [
  5, 150, 105,
];

export const getSelectionAreaRgb: GetSelectionAreaRgb = ({ mode }) =>
  mode === "include" ? INCLUDE_SELECTION_AREA_RGB : EXCLUDE_SELECTION_AREA_RGB;
